import Button from 'components/Button';
import {FC, ReactNode} from 'react';
import {twMerge} from 'tailwind-merge';

export type ModalHeaderProps = {
    children: ReactNode;
    className?: string;
    id?: string;
    onClose?: () => void;
};

const ModalHeader: FC<ModalHeaderProps> = ({
    children,
    className,
    id,
    onClose,
}) => (
    <div
        className={twMerge(
            'border-b border-b-grey-300 p-4 pb-2 drop-shadow-none flex',
            className,
        )}
        id={id}
    >
        <span className="flex-1 text-base font-semibold">{children}</span>
        {onClose && (
            <Button
                icon="close_small"
                kind="tertiary"
                onClick={onClose}
                size="sm"
            />
        )}
    </div>
);

export default ModalHeader;
